import { inject } from '@angular/core';
import { HttpRequest, HttpInterceptorFn, HttpHandlerFn, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { ToastService } from '../services/toast.service';
import { ResponseJson } from '../models/model';
import { HealthCheckService } from '../../services/health-check.service';

export const ErrorInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const toastService = inject(ToastService)
    const authService = inject(AuthenticationService)
    const healthCheckService = inject(HealthCheckService);
    const isHealthCheck = request.url.includes('/healthcheck/');

    return next(request).pipe(
        tap((res) => {
            if (res instanceof HttpResponse) {
                if (res.body && (res.body as ResponseJson<unknown>).success === false) {
                    toastService.error((res.body as ResponseJson<unknown>).message, 'Error')
                }
            }
        }),
        catchError((error: HttpErrorResponse) => {
            if (isHealthCheck) {
                return throwError(() => new Error(error.message || 'Error During operation'));
            }
            return healthCheckService.checkHealth().pipe(
                switchMap((_result) => {
                    let isMaintenance = false;
                    healthCheckService.maintenance$.subscribe(val => isMaintenance = val).unsubscribe();
                    if (isMaintenance) {
                        healthCheckService.setMaintenanceMode(true);
                        return throwError(() => new Error('System is under maintenance.'));
                    } else {
                        if (error.status === 401) {
                            const isLoggedOut = !localStorage.getItem('token');
                            if (isLoggedOut) {
                                //If user is already logged out, don't show toast or trigger logout again
                                return EMPTY;
                            }
                            toastService.error("Your session has expired. Please login again.")
                            authService.logout()
                        } else if (error.status === 500) {
                            toastService.error('Internal Server Error');
                        }
                        return throwError(() => new Error(error.message || 'Error During operation'));
                    }
                })
            );
        }));
}
